<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
    class="balance-selector"
  >
    <template slot="select-header"> {{ letter.changeCoin }} </template>
    <template slot="select-content">
      <p class="coins-tip">{{ letter.attentionCoinUse }}</p>

      <p
        tagName="p"
        type="activeListItem"
        class="current-balance select-items active"
      >
        <span>{{ curBalanceItem.currency }}</span>
        <span>{{ letter.curBalance }}: {{ curBalanceItem.amount }}</span>
      </p>
      <List class="area-select-container">
        <ListItem
          v-show="item.currency !== curBalanceItem.currency"
          v-for="(item, index) in balanceList"
          type="locationItem"
          class="balance-list select-items"
          :dataCode="item.currency"
          :pointValue="item.currency"
          :key="index"
          @click="selectBalanceItem(item)"
        >
          <span>{{ item.currency }}</span>
          <span>{{ letter.curBalance }}: {{ item.amount }}</span>
        </ListItem>
      </List>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialStore/selectContainer';
import gameInfoConfig from '@configs/officialStore/globalGameInfoConfig';
import { mapState } from 'vuex';

export const HIDE_COINS_SELECTOR = 'hideCoinsSelector';
export default {
  computed: {
    ...mapState({
      letter: state => state.letter
    }),
    coinsName() {
      return gameInfoConfig[+this.$store.state.gameId].coinsName;
    }
  },
  props: ['curBalanceItem', 'balanceList'],
  methods: {
    selectBalanceItem(balanceItem) {
      this.$emit(HIDE_COINS_SELECTOR, balanceItem);
    }
  },
  mixins: [selectContainer]
};
</script>

<style lang="scss" scoped>
.balance-selector {
  z-index: 1002;
}
.balance-list,
.current-balance {
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 80px;
  line-height: 80px;
  margin-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: 1px solid #333;
  font-size: 28px;
  color: #333;
  transition: all 0.2s ease;
}

.current-balance.active {
  color: #b20000;
  border: 1px solid #b20000;
}
.coins-tip {
  margin-bottom: 24px;
  font-size: 24px;
  line-height: 28px;
  text-align: left;
  color: #b20000;
}
::v-deep .select-header {
  font-weight: bold;
}
</style>
